import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
const firebaseConfig = {
    apiKey: "AIzaSyB-4qaV5lC2gtucgrYPhbhNGTsfuElgbJE",
    authDomain: "chillhop-v2.firebaseapp.com",
    databaseURL: "https://chillhop-v2.firebaseio.com",
    projectId: "chillhop-v2",
    storageBucket: "chillhop-v2.appspot.com",
    messagingSenderId: "448512641610",
    appId: "1:448512641610:web:f34f3243ef04801afbf4b3"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();

export const db = firebase.firestore();